<template>
  <div>
    <v-container class="mb-4">
      <v-row class="align-center justify-center">
        <v-spacer></v-spacer>
        <v-btn-toggle v-model="view" dense mandatory>
          <v-btn text value="panel">Spiegel</v-btn>
          <v-btn text value="list">Liste</v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-btn
          color="info"
          text
          outlined
          :to="{
            name: 'Timetable',
            query: { code: codes },
          }"
          >Stundenpläne</v-btn
        >
        <v-btn
          color="info"
          class="ml-2"
          text
          outlined
          :to="{
            name: 'Meeting',
            query: { id: ids },
          }"
          >Treffen planen</v-btn
        >
      </v-row>
    </v-container>
    <template v-if="view == 'panel'">
      <v-card :loading="loading">
        <v-system-bar>Lehrpersonen-Spiegel</v-system-bar>
        <v-card-text>
          <PeoplePanel :value="filteredTeachers" />
        </v-card-text>
      </v-card>
    </template>
    <template v-if="view == 'list'">
      <v-card :loading="loading">
        <v-system-bar>Lehrpersonen-Liste</v-system-bar>

        <v-list>
          <PersonItem
            v-for="teacher in filteredTeachers"
            :value="teacher"
            :key="teacher.id"
          >
            <v-chip small v-if="teacher.division">{{
              teacher.division.code
            }}</v-chip>
          </PersonItem>
        </v-list>
      </v-card>
    </template>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import PersonItem from "common/components/PersonItem.vue";
import PeoplePanel from "common/components/PeoplePanel.vue";

import { sortPeople } from "common/utils/people.js";

export default defineComponent({
  name: "TeacherList",
  components: { PersonItem, PeoplePanel },
  props: ["filterDepartment", "filterDivision", "filterNew", "filterStvs"],

  data() {
    return {
      view: "list",
      teachers: [],
      loading: false,
    };
  },
  watch: {
    filterDepartment() {
      this.fetchData();
    },
    filterNew() {
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      if (this.filterNew) {
        this.teachers = await this.apiList({
          resource: "person/person",
          query: `group=teacher&new=true`,
        });
      } else if (this.filterDepartment > 0) {
        this.loading = true;
        const department = await this.apiGet({
          resource: "person/department",
          id: this.filterDepartment,
        });

        this.teachers = [...department.heads, ...department.members]
          .filter((el) => el.type.code == "teacher")
          // eslint-disable-next-line no-unused-vars
          .map(({ description, ...el }) => el);
        this.loading = false;
      } else {
        this.teachers = await this.apiList({
          resource: "person/person",
          query: `group=teacher`,
        });
      }
    },
  },

  computed: {
    codes() {
      return this.filteredTeachers.filter((el) => el.code).map((el) => el.code);
    },
    ids() {
      return this.filteredTeachers.map((el) => el.id);
    },
    filteredTeachers() {
      return sortPeople(
        this.teachers.filter(
          (el) =>
            (this.filterStvs || (el.code && el.code.length == 3)) &&
            (el.division == null ||
              this.filterDivision == 0 ||
              this.filterDivision == el.division.id)
        )
      );
    },
  },
  async created() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
});
</script>
